import { ColDef, ColGroupDef } from "ag-grid-community";

const formatLength = (lengthInInches: number | null | undefined): string => {
	if (lengthInInches === null || lengthInInches === undefined)
		lengthInInches = 0;
	const feet = Math.floor(lengthInInches / 12);
	const inches = lengthInInches % 12;
	return `${feet} ft ${inches} in`;
};

export const useTableData = () => {
	const columns: ColGroupDef[] = [
		{
			headerName: "Scrap",
			children: [
				{
					field: "Length",
					headerName: "Length",
					flex: 1,
					minWidth: 79,
					valueFormatter: (params) => formatLength(params.value),
					cellStyle: {
						textAlign: "center",
					},
				},
				{
					field: "Pieces",
					headerName: "Pieces",
					flex: 1,
					minWidth: 65,
					cellStyle: {
						textAlign: "center",
					},
				},
				{
					field: "ScrapReasonName",
					headerName: "Code",
					flex: 1,
					minWidth: 110,
					cellStyle: {
						textAlign: "right",
					},
				},
				{
					field: "Weight",
					headerName: "Weight",
					flex: 1,
					minWidth: 96,
					cellStyle: {
						textAlign: "right",
					},
				},
			],
		},
	];

	const defaultColDef: ColDef = {
		filter: false,
		floatingFilter: false,
		sortable: false,
		resizable: false,
		editable: false,
		suppressHeaderMenuButton: true,
	};

	return { columns, defaultColDef };
};
